import { lazy } from "react";
import routes from "./routesConfig/index";

const MyCalendar = lazy(() => import("../my-calendar/MyCalendar"));
const MyProfile = lazy(() => import("../SettingsPage/my-profile/MyProfile"));
const TimeRequests = lazy(() => import("../SettingsPage/time-requests/TimeRequests"));
const RaiseTimeRequest = lazy(() => import("../SettingsPage/time-requests/RaiseTimeRequest"));
const ApproveLeaves = lazy(() => import("../SettingsPage/leaves/approve-leaves/ApproveLeaves"));
// const ChatPage = lazy(() => import("../chat/Chat"));
// const Chat1Page = lazy(() => import("../chat/Home"));
const Conversaction = lazy(() => import("../Conversaction/Home"));

const generalRoutes = [
    { path: routes.myCalendar, component: MyCalendar, moduleKey: "calendar", permissionKey: "calendar_access" },
    { path: routes.myProfile, component: MyProfile, moduleKey: "hrms", permissionKey: "view_my_profile" },
    { path: routes.timeRequests, component: TimeRequests, moduleKey: "hrms", permissionKey: "approve_time_request" },
    { path: routes.addTimeRequest, component: RaiseTimeRequest, moduleKey: "hrms", permissionKey: 'raise_time_request' },
    { path: routes.myReportees, component: ApproveLeaves },
    { path: routes.chat, component: Conversaction },
    // { path: routes.altchat, component: Chat1Page },
    { path: routes.conversaction, component: Conversaction }
];

export default generalRoutes;
